import { createAction, props } from '@ngrx/store'
import { HubtypeCaseFilter } from 'models/hubtype-case-filter'
import { HubtypeCaseSort } from 'models/hubtype-case-sort'

export const setAgentsRealtimeColumns = createAction(
  '[Agents Realtime] Set Table Columns',
  props<{ columnsByKey: Record<string, boolean> }>()
)

export const toggleNavbarCollapse = createAction(
  '[Desk] Toggle Navbar Collapse'
)

export const toggleQueuePanelCollapse = createAction(
  '[Inbox] Toggle Queue Panel Collapse'
)

export const setUseInboxV2 = createAction(
  '[Inbox] Set Use Inbox V2',
  props<{ useInboxV2: boolean }>()
)

export const setInboxCasesSort = createAction(
  '[Inbox] Set Inbox Cases Sort',
  props<{ inboxCasesSort: HubtypeCaseSort }>()
)

export const setInboxCasesFilter = createAction(
  '[Inbox] Set Inbox Cases Filter',
  props<{ inboxCasesFilter: HubtypeCaseFilter }>()
)

export const setInboxSelectedQueues = createAction(
  '[Inbox] Set Inbox Selected Queues',
  props<{ inboxSelectedQueueIds: string[] }>()
)
